/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 16:30:24
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-27 21:09:20
 * @Description: file content
 * 通用工具类
 * 特点：
 * 1、纯前端操作，不能牵扯ajax
 */
import jsCookie from "js-cookie";

// import moment from 'moment'//导入文件
// moment.locale('zh-cn');//需要汉化

import md5 from "js-md5";

require("../ua-device/ua-format");
require("../ua-device/apple-device");
export default {
  cookie: jsCookie,
  // moment: moment,
  md5: md5,
  browser: {
    info: navigator.appVersion,
    versions: (function () {
      let u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1,
        presto: u.indexOf("Presto") > -1,
        webKit: u.indexOf("AppleWebKit") > -1,
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
        iPad: u.indexOf("iPad") > -1,
        webApp: u.indexOf("Safari") == -1,
        wx: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
        wxwork: u.includes('wxwork')
      };
    })(),
  },
  systemInfo: (function () {
    let formater = new UAFormat();
    let formaterResult = formater.getResult();
    let mobileModel = formaterResult.device.model;

    let mobileVendor = formaterResult.device.vendor;
    let mobileType = formaterResult.device.type;
    if (mobileModel == "iPhone") {
      mobileModel = window.MobileDevice.getModels().join(" or ");
      // iPhone X、iPhone XS
      var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
      // iPhone XS Max
      var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
      // iPhone XR
      var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
      if (isIPhoneX) {
        mobileModel = "iPhone X";
      }
      if (isIPhoneXSMax) {
        mobileModel = "iPhone XS Max";
      }
      if (isIPhoneXR) {
        mobileModel = "iPhone XR";
      }
    } else if (mobileModel == "unknown") {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1 || u.indexOf("Adr") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        mobileType = "mobile";
        var sss = u.split(";");
        for (var k = 0; k < sss.length; k++) {
          if (sss[k].indexOf("Build/") > -1) {
            mobileModel = sss[k].split("Build/")[0];
            mobileVendor = "";
          }
        }
      } else if (isIOS) {
        mobileType = "ios mobile";
      } else {
        mobileType = "Browser";
      }
    }
    if (mobileVendor.indexOf("ZTE ") > -1) {
      mobileVendor = "ZTE";
    }
    if (!window.starfish) {
      window.starfish = {};
    }
    return {
      model: mobileModel,
      vendor: mobileVendor,
      type: mobileType,
    };
  })(),
  randomCutArray(arr, selectedCount) {
    let result = [];
    let count = arr.length;
    for (let i = 0; i < selectedCount; i++) {
      let index = ~~(Math.random() * count) + i;
      result[i] = arr[index];
      arr[index] = arr[i];
      count--;
    }
    return result;
  },
  randomArray(arr) {
    return arr.sort(() => {
      return Math.random() > 0.5 ? -1 : 1;
    });
  },
  getRandomNum(maxNum) {
    return Math.floor(Math.random() * (maxNum + 1));
  },
  // 验证手机号码合法性
  isMobile: function (mobile) {
    return /^1+\d{10}$/.test(String(mobile).replace(/^0+/g, ""));
  },
  rgbToRgba(hex, alp) {
    var rgb = []; // 定义rgb数组
    if (/^\#[0-9A-F]{3}$/i.test(hex)) {
      //判断传入是否为#三位十六进制数
      let sixHex = "#";
      hex.replace(/[0-9A-F]/gi, function (kw) {
        sixHex += kw + kw; //把三位16进制数转化为六位
      });
      hex = sixHex; //保存回hex
    }
    if (/^#[0-9A-F]{6}$/i.test(hex)) {
      //判断传入是否为#六位十六进制数
      hex.replace(/[0-9A-F]{2}/gi, function (kw) {
        rgb.push(eval("0x" + kw)); //十六进制转化为十进制并存如数组
      });
      return `rgba(${rgb.join(",")},${alp})`; //输出RGB格式颜色
    } else {
      return "rgb(0,0,0)";
    }
  },
  getViewSize() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    };
  },
  getObjFromObjArrayByProp(filterObj, objList) {
    let tmpObj = null;
    for (let index = 0; index < objList.length; index++) {
      let isPropEqual = true;
      Object.keys(filterObj).forEach((k) => {
        if (filterObj[k] != objList[index][k]) {
          isPropEqual = false;
        }
      });
      if (isPropEqual) {
        tmpObj = objList[index];
      }
    }
    return tmpObj;
  },
  /**
   * 计算字符串长度(英文占1个字符，中文汉字占2个字符)
   * @param {*} str
   */
  getStrBlen(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  /**
   * 拨打电话
   */
  makePhoneCall(phone) {
    window.location.href = "tel:" + phone;
  },
  redirectTo(url) {
    window.location.href = url;
  },
  /**
   * obj 
   * abc: {
        efg: {
          hij: "hijvale"
        }
      }
   */
  findKeyByStrValueInObj(obj, val) {
    let result = "";
    Object.keys(obj).forEach((k) => {
      if (obj[k] == val) {
        result = k;
        return false;
      } else if (typeof obj[k] == "object") {
        let result1 = this.findKeyByStrValueInObj(obj[k], val);
        if (result1) {
          result += k + "." + result1;
        }
      }
    });
    return result;
  },
  /**
   * 用户摇动手机 需要https
   * @param {*} fn 回调函数
   */
  shake(fn) {
    return new Promise((resolve) => {
      const shake = 3000;
      let last_update = 0;
      let x = 0;
      let y = 0;
      let z = 0;
      let last_x = 0;
      let last_y = 0;
      let last_z = 0;
      const deviceMotionHandler = (eventData) => {
        const acceleration = eventData.accelerationIncludingGravity;
        const currTime = new Date().valueOf();
        const diffTime = currTime - last_update;
        if (diffTime > 100) {
          last_update = currTime;
          x = acceleration.x;
          y = acceleration.y;
          z = acceleration.z;
          const speed = (Math.abs(x + y + z - last_x - last_y - last_z) / diffTime) * 20000;
          if (speed > shake) {
            fn();
          }
          last_x = x;
          last_y = y;
          last_z = z;
        }
      };

      if (window.DeviceMotionEvent) {
        window.addEventListener("devicemotion", deviceMotionHandler, false);
        resolve(true);
      } else {
        console.log("本设备不支持devicemotion事件");
        resolve(false);
      }
    });
  },
  windowScroll(callback) {
    window.addEventListener("scroll", callback, true);
  },
  getGuid() {
    let tmpGuid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      tmpGuid += n;
      if (i == 8 || i == 12 || i == 16 || i == 20) tmpGuid += "";
    }
    return tmpGuid;
  },
  _openInterceptor(params) {
    let query = "";
    for (let key in params) {
      query += `${key}=${params[key]}&`;
    }
    return query;
  },
  parseTime(time,format='{y}年{m}月{d}日 {h}:{i}:{s}') {
    if (arguments.length === 0 || !time) {
      return null
    }
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          time = parseInt(time)
        } else {
          // support safari
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    return format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
  }
};
